<template>
  <auth-layout>
    <div class="mb-6">
      <div
        v-if="requestSent"
        class="bg-positive-100 py-2 px-4 mb-4 text-positive-800 border border-positive-400"
      >
        <p>
          Reset link successfully sent. Please check you email and follow the
          instructions.
        </p>
      </div>
      <h2 class="xl:text-4xl xl:font-light text-2xl font-bold">
        Request Password Reset
      </h2>
      <p class="mt-2">
        <icon-link :href="route('login')" icon="arrow-thin-left-circle">
          Back to login
        </icon-link>
      </p>
    </div>
    <form @submit.prevent="request">
      <auth-input
        v-model="auth.email"
        label="Email"
        input-type="email"
        :error="getError('email')"
        :required="true"
        placeholder="e.g. your.name@email.com"
        :loading="loading"
        :autocomplete="true"
      />

      <app-button type="submit" class="mt-8 mb-4">
        Send Reset Link
      </app-button>
      <p class="text-center">
        <a
          :href="
            `mailto:${$config.emails.technical}?subject=APC ${$config.name} Login issue`
          "
          class="icon-link underline"
        >
          Having problems registering?
        </a>
      </p>
    </form>
  </auth-layout>
</template>

<script>
import { requestMixin } from "../mixins/request";
export default {
  name: "Request",
  mixins: [requestMixin],
  data() {
    return {
      auth: {
        email: ""
      },
      requestSent: false,
      loading: false
    };
  },
  created() {
    document.title = `Password Reset Request :: ${document.title}`;
  },
  methods: {
    request() {
      this.loading = true;
      this.requestSent = false;
      return axios
        .post(route("password.email"), this.auth)
        .then(response => this.requestResponse(response))
        .catch(error => this.requestError(error));
    },
    requestResponse() {
      this.loading = false;
      this.auth.email = "";
      this.requestSent = true;
    }
  }
};
</script>
